(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["forbalance-discount-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const popup = document.querySelector('[data-fb-discount-popup]');
    if (!popup || popup.hasAttribute('hidden')) return;

    const dialog = popup.querySelector('.fb-discount-popup__dialog');
    const closers = popup.querySelectorAll('[data-fb-discount-popup-close]');
    const form = popup.querySelector('.fb-discount-popup__form');
    const success = popup.querySelector('[data-fb-discount-popup-success]');
    const frequency = popup.dataset.frequency || 'session';
    const delay = Number(popup.dataset.openDelay || 0) * 1000;
    const storageKey = 'fb-discount-popup-seen';
    const submitKey = 'fb-discount-popup-submit';
    const subscribedKey = 'fb-discount-popup-subscribed';

    const hasSubscribed = () => localStorage.getItem(subscribedKey) === 'true';

    const showNewsletterReminder = (opener) => {
      const prompt = opener.closest('[data-newsletter-prompt]');
      if (!prompt) return;

      const title = prompt.querySelector('[data-newsletter-prompt-title]');
      const copy = prompt.querySelector('[data-newsletter-prompt-copy]');

      if (title) title.textContent = 'Rabat na start masz już odebrany';
      if (copy) copy.textContent = 'Jeśli jeszcze go nie wykorzystałaś, kod -20% znajdziesz w e-mailu od nas.';
      opener.remove();
    };

    const shouldAutoOpen = () => {
      if (hasSubscribed()) return false;
      if (popup.dataset.autoOpen !== 'true') return false;
      if (frequency === 'always') return true;
      if (frequency === 'session') return sessionStorage.getItem(storageKey) !== 'true';
      return localStorage.getItem(storageKey) !== new Date().toDateString();
    };

    const markSeen = () => {
      if (frequency === 'session') sessionStorage.setItem(storageKey, 'true');
      if (frequency === 'day') localStorage.setItem(storageKey, new Date().toDateString());
    };

    const openPopup = (closeCartDrawer = false) => {
      const activeCartDrawer = closeCartDrawer && document.querySelector('cart-drawer.active');
      if (activeCartDrawer) {
        activeCartDrawer.close();
        window.setTimeout(openPopup, 180);
        return;
      }

      popup.classList.add('is-open');
      document.documentElement.classList.add('fb-discount-popup-open');
      markSeen();
      window.setTimeout(() => dialog && dialog.focus(), 60);
    };

    const closePopup = () => {
      popup.classList.remove('is-open');
      document.documentElement.classList.remove('fb-discount-popup-open');
    };

    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-fb-discount-popup-open], a[href="#fb-discount-popup"]');
      if (!opener) return;

      event.preventDefault();
      if (hasSubscribed()) {
        showNewsletterReminder(opener);
        return;
      }
      openPopup(true);
    });

    closers.forEach((closer) => closer.addEventListener('click', closePopup));

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && popup.classList.contains('is-open')) closePopup();
    });

    document.addEventListener('click', (event) => {
      const copyButton = event.target.closest('[data-discount-code]');
      if (!copyButton || !navigator.clipboard) return;
      navigator.clipboard.writeText(copyButton.dataset.discountCode);
    });

    if (form) {
      form.addEventListener('submit', () => {
        sessionStorage.setItem(submitKey, 'true');
      });
    }

    if (success && sessionStorage.getItem(submitKey) === 'true') {
      sessionStorage.removeItem(submitKey);
      localStorage.setItem(subscribedKey, 'true');
      localStorage.setItem(storageKey, new Date().toDateString());
      sessionStorage.setItem(storageKey, 'true');
      openPopup();
      return;
    }

    if (shouldAutoOpen()) {
      window.setTimeout(() => {
        if (document.querySelector('cart-drawer.active')) return;
        openPopup();
      }, delay);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["forbalance-newsletter-discount"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-discount-code]');
    if (!button || !navigator.clipboard) return;

    navigator.clipboard.writeText(button.dataset.discountCode).then(() => {
      const previousText = button.textContent;
      button.textContent = 'Skopiowano';
      window.setTimeout(() => {
        button.textContent = previousText;
      }, 1600);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
